/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoInstagramIcon16Light } from './LogoInstagramIcon16Light';
import { LogoInstagramIcon16Regular } from './LogoInstagramIcon16Regular';
import { LogoInstagramIcon16Solid } from './LogoInstagramIcon16Solid';
import { LogoInstagramIcon20Light } from './LogoInstagramIcon20Light';
import { LogoInstagramIcon20Regular } from './LogoInstagramIcon20Regular';
import { LogoInstagramIcon20Solid } from './LogoInstagramIcon20Solid';
import { LogoInstagramIcon24Regular } from './LogoInstagramIcon24Regular';
import { LogoInstagramIcon24Solid } from './LogoInstagramIcon24Solid';
import { LogoInstagramIcon32Regular } from './LogoInstagramIcon32Regular';
import { LogoInstagramIcon64Regular } from './LogoInstagramIcon64Regular';
var sizes = {
    16: {
        light: LogoInstagramIcon16Light,
        regular: LogoInstagramIcon16Regular,
        solid: LogoInstagramIcon16Solid,
    },
    20: {
        light: LogoInstagramIcon20Light,
        regular: LogoInstagramIcon20Regular,
        solid: LogoInstagramIcon20Solid,
    },
    24: {
        regular: LogoInstagramIcon24Regular,
        solid: LogoInstagramIcon24Solid,
    },
    32: {
        regular: LogoInstagramIcon32Regular,
    },
    64: {
        regular: LogoInstagramIcon64Regular,
    },
};
export var LogoInstagramIcon = forwardRef('LogoInstagramIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
